import React from 'react'
import {observer} from 'mobx-react-lite'
import {SubmitHandler, useForm} from 'react-hook-form'
import {Box, Button, Stack, Text} from '../../../vanilla'
import {AddressFields} from '../../../components/forms'
import {OrderAddress} from '../../../types/store/basket'
import {editShippingAddressFormField} from '../styles.css'
import { AddressFormFields } from '../../../types/forms'
import {useBasketStore} from '../../../store/hooks/useStore'

interface AddAddressFormProps  {
  setDeliveryAddress: (address: OrderAddress, saveAddress?: boolean) => void
  cleanupFunction?: () => void
}

export const AddAddressForm = observer(
  ({setDeliveryAddress, cleanupFunction}: AddAddressFormProps) => {

  const {
    deliveryPostalCode
  } = useBasketStore()

  const form = useForm<AddressFormFields>({
      mode: 'onBlur',
      defaultValues: {
        title: '',
        postalCode: deliveryPostalCode || ''
      },
    })

    const onSubmit: SubmitHandler<AddressFormFields> = async ({searchForAddress, ...data}) => {
      if (setDeliveryAddress && typeof setDeliveryAddress === 'function') {
        if (!data.addressId) {
          const defaultAddressId = (data.address1 ?? data.address2).substring(0, 20)
          data.addressId = defaultAddressId
          form.setValue('addressId', defaultAddressId)
        }
        await setDeliveryAddress({...data, c_updateSource: 'Book Delivery'}, true)
        if (cleanupFunction) {
          cleanupFunction()
        }
      }
    }

    return (
      <Stack bg="gray25" spacing="0px">
        <Box paddingX="24px" paddingTop="28px">
          <Text variant="text4">Add new address</Text>
        </Box>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <AddressFields
            enableEnterManually
            showDeliveryAvailability={false}
            gap="0px"
            form={form}
            inputGroupProps={{
              className: editShippingAddressFormField,
            }}
            formContainerPartsProps={{
              top: {bg: 'gray25', paddingBottom: '0px'},
              middle: {bg: 'gray25', paddingY: '0px'},
              bottom: {bg: 'gray25', paddingTop: '0px'},
            }}
          />
          <Box marginTop="16px" paddingX="24px" paddingBottom="52px">
            <Button variant="secondary" type="submit" size="sm">
              Add address
            </Button>
          </Box>
        </form>
      </Stack>
    )
  }
)
